import { useEffect, useState } from 'react';
import { getSession, onSessionChange, type StoredSession } from '../../../lib/auth-store';
import type { ScorerAuthKind } from './types';

const LINK_KEY = 'pingo.caddy.link';
const CODE_KEY = 'pingo.caddy.code';

/** The caddy portal link (/c/:token) this device logged in with — to return there after logout. */
export function rememberCaddyLink(token: string, code: string): void {
  try {
    localStorage.setItem(LINK_KEY, token);
    localStorage.setItem(CODE_KEY, code.trim().toUpperCase());
  } catch {
    /* ignore */
  }
}

export function lastCaddyLink(): string | null {
  try {
    return localStorage.getItem(LINK_KEY);
  } catch {
    return null;
  }
}

export function lastCaddyCode(): string | null {
  try {
    return localStorage.getItem(CODE_KEY);
  } catch {
    return null;
  }
}

/** Reactive view of the stored scorer session (cleared by lib/api.ts on 401). */
export function useScorerSession(kind: ScorerAuthKind): StoredSession | null {
  const [session, setSession] = useState(() => getSession(kind));
  useEffect(
    () =>
      onSessionChange((k) => {
        if (k === kind) setSession(getSession(kind));
      }),
    [kind],
  );
  return session;
}
